/* tslint:disable */
/* eslint-disable */
/**
 * Simple API with JWT Auth
 * A minimal OpenAPI spec with JWT authentication and simple models.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { updateIsDeleted, isDeleted, isNew, updateIsNew } from "@/api/util";
import { registerMeta } from "@/api/meta";
import {
  propertyMeta,
  typeMeta,
  typeMetaEnum,
  MetaTypesBase,
  EnumMetaType,
  MetaType,
  MetaTypeBase,
  PropertyMeta,
  AssignOptions,
  AssignOptionsRequired,
  FilterVarsType,
  getAssignOptions,
} from "../common";

// May contain unused imports in some cases
// @ts-ignore
import type {
  PaymentReportsDTO,
  PaymentReportsDTOOptional,
  PaymentReportsDTOMetaI,
  PaymentReportsDTOTrackedI,
} from "./payment-reports-dto";
import {
  PaymentReportsDTOTracked,
  PaymentReportsDTOMeta,
} from "./payment-reports-dto";

/**
 *
 * @export
 * @interface PaymentReportsResultDTO
 */
export interface PaymentReportsResultDTOOptional {
  /**
   *
   * @type {string}
   * @memberof PaymentReportsResultDTO
   */
  queueId?: string;
  /**
   *
   * @type {PaymentReportsDTO}
   * @memberof PaymentReportsResultDTO
   */
  paymentReports?: PaymentReportsDTOOptional;
}

export interface PaymentReportsResultDTO extends PaymentReportsResultDTOOptional {
  /**
   *
   * @type {string}
   * @memberof PaymentReportsResultDTO
   */
  queueId?: string;
  /**
   *
   * @type {PaymentReportsDTO}
   * @memberof PaymentReportsResultDTO
   */
  paymentReports?: PaymentReportsDTO;
}

export interface PaymentReportsResultDTOTrackedI {
  /**
   *
   * @type {string}
   * @memberof PaymentReportsResultDTO
   */
  queueId?: string;
  queueIdIsSet: boolean;
  /**
   *
   * @type {PaymentReportsDTO}
   * @memberof PaymentReportsResultDTO
   */
  paymentReports?: PaymentReportsDTOTrackedI;
  paymentReportsIsSet: boolean;
}

transformDatesMap.set(
  "PaymentReportsResultDTO",
  function (model: PaymentReportsResultDTO) {
    const transformDatespaymentReports =
      transformDatesMap.get("PaymentReportsDTO");
    if (transformDatespaymentReports && model.paymentReports) {
      transformDatespaymentReports(model.paymentReports);
    }
  },
);

export type PaymentReportsResultDTOMetaI = MetaType<{
  //isDate: false
  //isDatetime: false
  queueId: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  paymentReports: PropertyMeta<PaymentReportsDTOMetaI>;
}>;

export var PaymentReportsResultDTOMeta: PaymentReportsResultDTOMetaI =
  {} as PaymentReportsResultDTOMetaI;
PaymentReportsResultDTOMeta = typeMeta("PaymentReportsResultDTO", {
  queueId: propertyMeta("queueId", false, false, false, MetaTypesBase.string),
  paymentReports: propertyMeta(
    "paymentReports",
    false,
    false,
    false,
    PaymentReportsDTOMeta,
  ),
});

const metaI = PaymentReportsResultDTOMeta;

registerMeta(() => {});

export class PaymentReportsResultDTOTracked implements PaymentReportsResultDTOTrackedI {
  changeTracker: boolean = false;
  //isNew: boolean = false
  queueId__I?: string = undefined;
  queueIdIsSet: boolean = false;
  set queueId(v: undefined | string) {
    if (v !== undefined) {
      this.queueId__I = v;
      this.queueIdIsSet = true;
    } else {
      this.queueId__I = v || undefined;
      this.queueIdIsSet = false;
    }
    this.changeTracker = true;
  }
  get queueId() {
    return this.queueId__I;
  }
  paymentReports__I?: PaymentReportsDTOTracked = undefined;
  paymentReportsIsSet: boolean = false;
  set paymentReports(v: undefined | PaymentReportsDTOTracked) {
    if (v !== undefined) {
      this.paymentReports__I = v;
      this.paymentReportsIsSet = true;
    } else {
      this.paymentReports__I = v || undefined;
      this.paymentReportsIsSet = false;
    }
    this.changeTracker = true;
  }
  get paymentReports() {
    return this.paymentReports__I;
  }
  constructor(
    config?: PaymentReportsResultDTOOptional,
    options?: AssignOptions,
  ) {
    if (config) {
      this.assignFrom(config, options);
    }
  }
  equals(other?: any): boolean {
    return this == other;
  }
  setIds() {
    this.paymentReports?.setIds();
  }
  assignFrom(
    config: PaymentReportsResultDTOOptional,
    options?: AssignOptions,
  ): PaymentReportsResultDTOTrackedI {
    const optionsRequired = getAssignOptions(options);
    if (config.queueId && this.queueIdApplyFilter(optionsRequired.filter)) {
      this.queueId = config.queueId;
      if (optionsRequired.unassign) this.queueIdIsSet = false;
      else this.queueIdIsSet = true;
    }
    if (
      config.paymentReports &&
      this.paymentReportsApplyFilter(optionsRequired.filter)
    ) {
      this.paymentReports = new PaymentReportsDTOTracked(
        config.paymentReports,
        options,
      );
      if (optionsRequired.unassign) this.paymentReportsIsSet = false;
      else this.paymentReportsIsSet = true;
    }
    if (optionsRequired.unassignChangeTracker) this.changeTracker = false;
    if (options?.isNew !== null && options?.isNew !== undefined)
      updateIsNew(this, optionsRequired.isNew);
    return this;
  }
  shouldRemove(skipPK: boolean = true): boolean {
    if (isNew(this) && isDeleted(this)) return true;
    return (
      !this.changeTracker && !this.anySet((a, b) => !skipPK || !a.isPrimary)
    );
  }
  removeUnset(filter?: FilterVarsType): PaymentReportsResultDTOTrackedI {
    const cloned = {} as PaymentReportsResultDTOTrackedI;
    if (
      this.queueIdIsSetDeep() &&
      this.queueIdApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.queueIdIsSet = true;
      cloned.queueId = this.queueId;
    } else {
      //cloned.queueIdIsSet = false
    }
    if (
      this.paymentReportsIsSetDeep() &&
      this.paymentReportsApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.paymentReportsIsSet = true;
      cloned.paymentReports = this.paymentReports?.removeUnset(filter);
    } else {
      //cloned.paymentReportsIsSet = false
    }
    return cloned;
  }
  unassignAll(filter?: FilterVarsType): PaymentReportsResultDTOTrackedI {
    if (!this.queueIdApplyFilter(filter)) this.queueIdIsSet = false;

    if (!this.paymentReportsApplyFilter(filter))
      this.paymentReportsIsSet = false;
    this.paymentReports?.unassignAll(filter);

    return this;
  }
  queueIdApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PaymentReportsResultDTOMeta.queueId,
      PaymentReportsResultDTOMeta,
      this.queueId,
      this,
    );
  }
  queueIdIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.queueIdIsSet && this.queueIdApplyFilter(filter)) return true;

    return false;
  }
  paymentReportsApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PaymentReportsResultDTOMeta.paymentReports,
      PaymentReportsResultDTOMeta,
      this.paymentReports,
      this,
    );
  }
  paymentReportsIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.paymentReportsIsSet && this.paymentReportsApplyFilter(filter))
      return true;
    return this.paymentReports?.anySet(filter) == true;

    return false;
  }
  anySet(filter?: FilterVarsType): boolean {
    if (this.changeTracker) return true;
    if (this.queueIdIsSetDeep(filter)) return true;
    if (this.paymentReportsIsSetDeep(filter)) return true;
    return false;
  }
}

import { transformDatesMap } from "@/api/mappers/dtoDateMapper";
